import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchOrganizationUserAnalytics";

export function* fetchOrganizationUserAnalytics(action: Actions.FetchOrganizationUserAnalyticsAction) {
    const { payload } = action;
    const { credentials, organizationId, props } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });

        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.getOrgUserAnalytics(organizationId, props);
        yield put(Actions.fetchOrganizationUserAnalyticsEnd(undefined, organizationId, result));
    } catch (e) {
        yield put(Actions.fetchOrganizationUserAnalyticsEnd(e, organizationId));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchOrganizationUserAnalytics() {
    yield takeEvery(Actions.FETCH_ORGANIZATION_USER_ANALYTICS, fetchOrganizationUserAnalytics);
}
